var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLightningSlash = function SvgIconLightningSlash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.981 1.696a1 1 0 0 0-1.712-.878l-3.787 4.06a1 1 0 0 0 1.462 1.364l1.385-1.485-.81 4.047a1 1 0 0 0 .63 1.132l4.6 1.725-.555.594a1 1 0 1 0 1.463 1.365l1.575-1.688a1 1 0 0 0-.38-1.618l-5.204-1.952zM3.827 3.01a1 1 0 0 1 1.413.067l4.11 4.52q.035.037.068.076L20.24 19.577a1 1 0 0 1-1.48 1.346l-3.413-3.754-5.616 6.014a1 1 0 0 1-1.712-.88l1.334-6.665-5.204-1.952a1 1 0 0 1-.38-1.618l3.515-3.77L3.76 4.424a1 1 0 0 1 .067-1.413m2.424 9.329 2.383-2.555 5.363 5.9-3.326 3.562.81-4.05a1 1 0 0 0-.63-1.132z",
    clipRule: "evenodd"
  })));
};
export default SvgIconLightningSlash;